<template>
  <div v-show="mostrarArticulos" class="product-workspace">
    <Keyboard v-model="keyboard" :layout="layout" />

    <!-- Buscador -->
    <div class="search-zone">
      <h2>Buscar producto</h2>
      <div class="search-line">
        <input
          ref="searchInput"
          class="search"
          type="text"
          placeholder="Buscar producto, artículo o platillo…"
          v-model="articuloBusqueda"
          @click="showKeyboard($event, 'normal')"
          @keyup.enter="Buscar($event.target.value)"
        />
        <button
          v-if="barcodeMode || (codigo_barra && codigo_barra.activo)"
          type="button"
          class="scanner"
          :class="{ active: barcodeMode }"
          @click="activarBarcode"
        >
          <v-icon small left>mdi-barcode-scan</v-icon>
          Código de barras
        </button>
        <button
          v-if="articuloBusqueda"
          type="button"
          class="scanner"
          @click="Limpiar()"
        >
          <v-icon small left>mdi-close</v-icon>
          Limpiar
        </button>
        <button
          v-if="keyboardSession"
          type="button"
          class="scanner"
          @click="Buscar(articuloBusqueda)"
        >
          Enter
        </button>
      </div>

      <!-- Barcode input -->
      <div
        v-if="barcodeMode || (codigo_barra && codigo_barra.activo)"
        class="search-line"
        style="margin-top: 10px"
      >
        <input
          ref="barcodeInput"
          class="search"
          type="text"
          placeholder="Escanear código de barras…"
          v-model="barcodeInput"
          @click="showKeyboard($event, 'numeric')"
          @keyup.enter="barcodeSearch"
        />
        <button type="button" class="scanner" @click="barcodeSearch">
          Enter
        </button>
      </div>
    </div>

    <!-- Catálogo: categorías + productos -->
    <div class="catalog">
      <!-- Columna de familias -->
      <nav class="categories">
        <p class="section-kicker">Categorías</p>
        <button
          v-for="grupo in grupos"
          :key="grupo.intFamilia"
          type="button"
          :class="{ active: familiaBusqueda && familiaBusqueda.intFamilia === grupo.intFamilia }"
          @click="SetFamilia(grupo)"
        >
          {{ grupo.strFamilia }}
        </button>
      </nav>

      <!-- Panel de productos -->
      <section class="product-pane">
        <div class="product-pane-top">
          <h3>{{ familiaBusqueda.strFamilia || "Productos" }}</h3>
          <span>{{ articulosOrdenados.length }} artículo<span v-if="articulosOrdenados.length !== 1">s</span></span>
        </div>

        <!-- Botones especiales -->
        <div v-if="!buscarArticulo" class="special-buttons">
          <button
            v-if="articulo_especial && articulo_especial.activo"
            type="button"
            class="new-btn"
            @click="especial('articulo')"
          >
            {{ articulo_especial.label }}
          </button>
          <button
            v-if="bebida_especial && bebida_especial.activo"
            type="button"
            class="new-btn"
            @click="especial('bebida')"
          >
            {{ bebida_especial.label }}
          </button>
        </div>

        <!-- Grid de productos -->
        <div class="products">
          <button
  v-for="articulo in articulosOrdenados"
  :key="articulo.intArticulo"
  type="button"
  class="product"
  @click="selectedArticulo(articulo)"
>
  <!-- Imagen del producto (si la config 8 lo permite y hay URL) -->
  <img
    v-if="!imageValidation.valor && articulo.strImagen"
    class="product-photo"
    :src="articulo.strImagen"
    :alt="articulo.strNombre"
  />
  <span v-else class="icon" aria-hidden="true">
    <v-icon small>mdi-food</v-icon>
  </span>

  <strong>{{ articulo.strNombreCorto }}</strong>
  <small>{{ articulo.strNombre }}</small>
  <span class="price">{{ toMoney(articulo.dblPF) }}</span>
</button>

          <p v-if="!articulosOrdenados.length" class="empty">
            <span class="symbol">📦</span>
            <b>Sin artículos</b>
            Selecciona una categoría o busca por nombre.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
var numeral = require("numeral");
import { Toast } from "../controllers/DataController.js";
import { Session } from "../controllers/DataController.js";
import Keyboard from "./Keyboard.vue";

export default {
  name: "CapturaArticulos",
  props: {
    version: { type: String, default: "desktop" },
    idOrder: { type: Number, default: 0 },
    idComponent: { type: String, default: "tipoPago" },
    grupos: { type: Array, default: () => [] },
    articulos: { type: Array, default: () => [] },
    articulo_especial: { type: Object, default: () => ({}) },
    bebida_especial: { type: Object, default: () => ({}) },
    codigo_barra: { type: Object, default: () => ({}) },
  },
  components: { Keyboard },
  data() {
    return {
      tipo: "",
      buscarArticulo: false,
      articuloBusqueda: "",
      familiaBusqueda: {},
      articulosMuestra: [],
      image: [],
      imageValidation: this.$config.opciones.find((c) => c.id == 8),
      config_10: false,
      barcodeMode: false,
      barcodeInput: "",
      barcode: "",
      keyboardSession: false,
      layout: "compact",
      keyboard: { visible: false, input: null },
      mostrarArticulos: true,
    };
  },
  computed: {
    articulosOrdenados() {
      return this.articulosMuestra
        .slice()
        .sort((a, b) => a.strNombre.localeCompare(b.strNombre));
    },
    getColBusqueda() {
      return this.buscarArticulo ? "col-10" : "col-12";
    },
    images() {
      let images = [];
      this.articulos.forEach((articulo) => {
        images.push(articulo.strImagen2);
      });
      return images;
    },
  },
  mounted() {
    try {
      this.keyboardSession = new Session().keyboard;

      let config = this.$config.opciones.find((c) => c.id == 10);
      this.config_10 = !!config.valor;

      let config_20 = this.$config.opciones.find((c) => c.id == 20);
      this.mostrarArticulos = !config_20.valor;
    } catch (e) {
      this.$toast.error("Error en configuracion 10. " + e, new Toast());
    }
  },
  methods: {
    showKeyboard(e, layout) {
      if (this.keyboardSession) {
        this.layout = layout;
        this.keyboard.input = e.target;
        this.keyboard.visible = true;
      }
    },
    toMoney(value) {
      return numeral(value).format("$0,0.00");
    },
    selectedArticulo(articulo) {
      this.$emit("selectedarticulo", articulo);
      if (!this.config_10) this.Limpiar();
    },
    SetFamilia(familia) {
      this.$emit("changed", familia);
      this.buscarArticulo = true;
      this.familiaBusqueda = familia;
      this.filterArticulos(this.articulos, familia.strFamilia);
    },
    Limpiar() {
      this.buscarArticulo = false;
      this.familiaBusqueda = {};
      this.articuloBusqueda = "";
    },
    resize(img) {
      this.image = [img];
      this.$viewer.show();
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    Buscar(value) {
      this.articuloBusqueda = value;
      if (value != "") {
        this.buscarArticulo = true;
        this.filterArticulosNombre(this.articulos, value);
      } else {
        this.buscarArticulo = false;
        this.Limpiar();
      }
    },
    filterArticulos(articulos, familia) {
      this.articulosMuestra = articulos.filter(
        (articulo) => articulo.strFamilia == familia
      );
    },
    filterArticulosNombre(articulos, nombre) {
      const nombreBusqueda = nombre.toLowerCase();
      this.articulosMuestra = articulos.filter((articulo) => {
        const nombreCompleto = articulo.strNombre.toLowerCase();
        const nombreCorto = articulo.strNombreCorto.toLowerCase();
        const precio = numeral(articulo.dblPF).format("$0,0.00").toLowerCase();
        return (
          nombreCompleto.includes(nombreBusqueda) ||
          nombreCorto.includes(nombreBusqueda) ||
          precio.includes(nombreBusqueda)
        );
      });
    },
    activarBarcode() {
      this.barcodeMode = true;
      this.$nextTick(() => {
        if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus();
      });
    },
    especial(version) {
      this.$emit("especial", version);
      this.Limpiar();
    },
    barcodeSearch() {
      this.barcode = this.barcodeInput;
      this.barcodeInput = "";
      let articulo = this.articulos.find((x) => x.strCodigoBarras == this.barcode);
      if (articulo) {
        this.$emit("barcode", articulo);
      } else {
        this.$toast.error(
          "No se encontro el articulo con codigo " + this.barcode,
          new Toast()
        );
      }
    },
  },
};
</script>

<style scoped>
.product-workspace {
  /* Tokens por si el main no los define globalmente */
  --primary: #0353a4;
  --primary-hover: #034582;
  --primary-light: #347ea8;
  --primary-tint: #eef5f9;
  --surface: #fff;
  --surface-alt: #fafbfc;
  --border: #e2e4e8;
  --border-strong: #c7cbd1;
  --text: #1a1d23;
  --text-soft: #33363c;
  --muted: #6b7280;
  --r-sm: 8px;
  --r-md: 14px;

  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 3px 12px rgba(17, 29, 45, 0.045);

  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  color: var(--text);
}

/* ==== Buscador ==== */
.search-zone {
  padding: 16px 18px;
  border-bottom: 1px solid var(--border);
  flex: none;
}
.search-zone h2 {
  font-size: 16px;
  margin: 0 0 11px;
  letter-spacing: -0.02em;
}
.search-line {
  display: flex;
  gap: 8px;
  align-items: stretch;
}
.search {
  height: 46px;
  flex: 1;
  min-width: 0;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--r-sm);
  padding: 0 12px;
  background: var(--surface);
  color: var(--text);
  font: inherit;
}
.search:focus,
.search:focus-visible {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 5px rgba(52, 126, 168, 0.22);
}
.scanner {
  height: 46px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--surface);
  padding: 0 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--primary);
}
.scanner:hover {
  border-color: var(--primary-light);
  background: var(--primary-tint);
}
.scanner.active {
  border-color: var(--primary);
  background: var(--primary-tint);
  color: var(--primary);
}

.special-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.special-buttons .new-btn {
  background: var(--primary);
  color: #fff;
  border: 0;
  border-radius: var(--r-sm);
  min-height: 40px;
  padding: 10px 14px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
}
.special-buttons .new-btn:hover {
  background: var(--primary-hover);
}

/* ==== Catálogo ==== */
.catalog {
  min-height: 0;
  display: grid;
  grid-template-columns: 158px minmax(0, 1fr);
  flex: 1 1 auto;
}

/* Categorías */
.categories {
  padding: 17px 9px;
  border-right: 1px solid var(--border);
  background: var(--surface-alt);
  overflow-y: auto;
}
.categories .section-kicker {
  padding: 0 9px;
  margin-bottom: 12px;
  font-size: 10px;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 700;
  letter-spacing: 0.07em;
}
.categories button {
  display: block;
  width: 100%;
  padding: 13px 10px;
  min-height: 44px;
  background: transparent;
  border: 0;
  border-radius: var(--r-sm);
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-soft);
  margin-bottom: 3px;
  cursor: pointer;
}
.categories button:hover:not(.active) {
  background: var(--surface);
}
.categories button.active {
  background: var(--primary);
  color: #fff;
  font-weight: 700;
}

/* Panel de productos */
.product-pane {
  padding: 13px 15px 18px;
  overflow-y: auto;
}
.product-pane-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
}
.product-pane-top h3 {
  font-size: 15px;
  margin: 0;
}
.product-pane-top span {
  color: var(--muted);
  font-size: 11px;
}

.products {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
  gap: 10px;
}
.product {
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  background: var(--surface);
  padding: 12px;
  text-align: left;
  min-height: 155px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  color: var(--text);
  font: inherit;
  transition: 0.15s ease;
}
.product:hover {
  border-color: var(--primary-light);
  box-shadow: 0 2px 10px rgba(3, 83, 164, 0.12);
}
.product .icon {
  width: 35px;
  height: 35px;
  border-radius: var(--r-sm);
  background: var(--surface-alt);
  display: grid;
  place-items: center;
  font-size: 21px;
  color: var(--primary);
}
.product strong {
  font-size: 13px;
  line-height: 1.4;
}
.product small {
  color: var(--muted);
  font-size: 10px;
  line-height: 1.35;
}
.product .price {
  margin-top: auto;
  font-size: 14px;
  font-weight: 700;
  color: var(--primary);
  font-variant-numeric: tabular-nums;
}
.product .product-photo {
  display: block;
  width: 108px;
  height: 108px;
  flex: none;
  align-self: center;
  border-radius: 8px;
  object-fit: contain;
  background: var(--surface-alt);
  pointer-events: none; 
}

/* Empty */
.empty {
  text-align: center;
  color: var(--muted);
  padding: 52px 10px;
  font-size: 12px;
  line-height: 1.5;
  grid-column: 1/-1;
}
.empty .symbol {
  font-size: 26px;
  display: block;
}
.empty b {
  display: block;
  color: var(--text);
  font-size: 14px;
  margin: 10px 0 5px;
}

/* ==== Responsive ==== */
@media (max-width: 980px) {
  .catalog {
    grid-template-columns: 135px minmax(0, 1fr);
  }
}
@media (max-width: 700px) {
  .catalog {
    grid-template-columns: 120px 1fr;
  }
  .search-line {
    flex-wrap: wrap;
  }
  .scanner {
    flex: none;
  }
}
@media (max-width: 480px) {
  .catalog {
    grid-template-columns: 105px minmax(0, 1fr);
  }
  .categories {
    padding: 9px 5px;
  }
  .categories button {
    font-size: 12px;
    padding: 8px 5px;
  }
  .products {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
  }
  .product {
    padding: 9px;
    min-height: 150px;
  }
  .product .icon {
    width: 28px;
    height: 28px;
  }
  .product strong {
    font-size: 12px;
  }
  .product .product-photo {
    width: 80px;
    height: 80px;
  }
}

@media (min-width: 1500px) {
  .search-zone {
    padding: 18px 20px;
  }
  .search-zone h2 {
    font-size: 20px;
  }
  .search,
  .scanner {
    height: 52px;
    font-size: 15px;
  }
  .catalog {
    grid-template-columns: 185px minmax(0, 1fr);
  }
  .categories button {
    font-size: 16px;
    padding: 15px 12px;
  }
  .product-pane {
    padding: 18px;
  }
  .products {
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 12px;
  }
  .product {
    min-height: 180px;
    padding: 15px;
  }
  .product strong {
    font-size: 16px;
  }
  .product small {
    font-size: 13px;
  }
  .product .price {
    font-size: 16px;
  }
  .product .product-photo {
    width: 130px;
    height: 130px;
  }
}
</style>